import script from "./StaffOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./StaffOrder.vue?vue&type=script&lang=ts&setup=true"

import "./StaffOrder.vue?vue&type=style&index=0&id=0cd9142e&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cd9142e"]])

export default __exports__